/** @format */

export enum MLItemType {
  BRAND = 'B', // A brand name, case sensitive, e.g. Nike
  CATEGORY = 'C', // A category, like Men's Apparel, but represented as an internal code like 12301_202105
  KEYWORD = 'K', // A keyword or phrase suggestion from SAYT
  PINNED_CONTENT_SPOT = 'PCS', // For Pinned Content Spot. Use with MLEventType.PINNED_CONTENT_SPOTS
  PINNED_PRODUCT = 'PP', // For pinned product. Use with MLEventType.SEARCH.
  PRODUCT = 'P', // A product ECODE that is a roll up of all SKUs. Use with MLEventType.SEARCH.
  SPONSORED_PINNED_CONTENT = 'SPC', // For Criteo/Sponsored Pinned Content. Use with MLEventType.SPONSORED_PINNED_CONTENT
  SPONSORED_PRODUCT = 'SP', // For Sponsored Products. Use with MLEventType.SPONSORED_PRODUCTS
}
